var _path, _rect, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 32,
    viewBox: "0 0 46 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.661 25.9876C28.3468 26.5577 25.0982 28.3235 23.4538 29.5423C23.1028 29.8025 22.6278 29.845 22.2541 29.6188C20.5897 28.6113 17.5905 26.8477 15.0508 25.9876C12.0695 24.978 6.47625 25.0202 3.07353 25.2101C2.49284 25.2425 2 24.7838 2 24.2022V3.29108C2 2.77712 2.38697 2.34725 2.89954 2.30958C6.01508 2.08058 13.0168 1.84731 16 2.85769C18.4163 3.67607 20.6183 5.06177 22.2439 6.1866C22.6206 6.44725 23.1233 6.42434 23.4916 6.15191C25.3428 4.78244 28.6151 3.05882 31.661 2.38561C34.4469 1.76988 40.0712 2.00962 43.1158 2.29366C43.6209 2.34078 44 2.76809 44 3.27541V24.9235C44 25.5002 43.5145 25.9564 42.9391 25.9183C40.0474 25.7272 34.9985 25.4136 31.661 25.9876Z",
    stroke: "#1A1123",
    strokeWidth: 3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.9832,
    y: 11.4094,
    width: 3.79661,
    height: 3.77632,
    rx: 1,
    fill: "#1A1123"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20.9832,
    y: 18.49,
    width: 3.79661,
    height: 3.77632,
    rx: 1,
    fill: "#1A1123"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.bc4cb3f077f7ca1418a145542bdcef12.svg";
export { ForwardRef as ReactComponent };